// extracted by css-extract-rspack-plugin
export default {"cls1":"Configuration-cls1_BtA","cls2":"Configuration-cls2_vRy Configuration-cls1_BtA"};